import { ToastProvider as ContextToastProvider } from '@contexts/ToastContext';
import React from 'react';
import ToastContainer from './ToastContainer';

interface ToastProviderProps {
  children: React.ReactNode;
}

const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => (
  <ContextToastProvider>
    {children}
    <ToastContainer />
  </ContextToastProvider>
);

export default ToastProvider;
